import BoxWrapper from 'blocks/BoxWrapper';
import { Row } from 'blocks/CommonLayout';
import { RowItem } from 'blocks/Row';
import { Title } from 'blocks/Text';
import Card from 'components/Card';
import WarnBox from 'components/WarnBox/inxex';
import { AwardTicketsContext } from 'context/AwardTicketsProvider';
import classnames from 'helper/classNames';
import { getAlphabetDate, getNextAlphabetDate, getPrevAlphabetDate } from 'helper/date';
import { useContext } from 'react';
import BookFlightItem from '../BookFlightItem';
import * as S from './step2.styles';

const Step2 = () => {
  const context = useContext(AwardTicketsContext);

  const renderDate = (date, active: boolean = false) => (
    <S.Step2DateBox
      $active={active}
      as={Row}
      justify="center"
      align="center"
      className={classnames('date-box', { active })}
    >
      {date}
    </S.Step2DateBox>
  );

  if (!context.dataForm) return null;

  return (
    <S.Wrapper>
      <BoxWrapper>
        <Row justify="center">
          <Title size="large">
            {context.dataForm.departure} To {context.dataForm.destination}
          </Title>
        </Row>
      </BoxWrapper>

      <BoxWrapper>
        <WarnBox text="COVID-19 insurance is included with your ticket so that you can travel the world with confidence. And if you travel plans change, you can rebook your flight for free (fare difference may apply.)" />
      </BoxWrapper>

      <BoxWrapper>
        <Card space="small">
          <BoxWrapper>
            <Row>
              <S.Step2HeadResult>{context.fareFlights.length} results</S.Step2HeadResult>
            </Row>
          </BoxWrapper>

          <BoxWrapper>
            <Row>
              <RowItem>{renderDate(getPrevAlphabetDate(context.dataForm.dateTime, 2))}</RowItem>
              <RowItem>{renderDate(getPrevAlphabetDate(context.dataForm.dateTime, 1))}</RowItem>
              <RowItem>{renderDate(getAlphabetDate(context.dataForm.dateTime), true)}</RowItem>
              <RowItem>{renderDate(getNextAlphabetDate(context.dataForm.dateTime, 1))}</RowItem>
              <RowItem>{renderDate(getNextAlphabetDate(context.dataForm.dateTime, 2))}</RowItem>
            </Row>
          </BoxWrapper>

          <BoxWrapper>
            {context.fareFlights.map((flight, index) => (
              <BookFlightItem fareFligt={flight} key={`fare-flight-${index}`} />
            ))}
          </BoxWrapper>
        </Card>
      </BoxWrapper>
    </S.Wrapper>
  );
};

export default Step2;
